import { SummarizerConfig } from '../../types/summarizer';
// Import custom component (we'll create it next)
// import TwitterThreadOutput from '../../components/summarizer/custom/TwitterThreadOutput';

export const twitterThreadSummarizerConfig: SummarizerConfig = {
  // Basic identification
  id: 'twitter-thread-summarizer',
  title: 'Twitter Thread Summarizer',
  description: 'Summarize Twitter threads and conversations with social media insights',
  version: '1.0.0',

  // Categorization
  category: 'social',
  tags: ['twitter', 'thread', 'social-media', 'conversation'],

  // Input configuration
  inputs: {
    file: {
      enabled: false, // Twitter threads are accessed via URL
    },
    url: {
      enabled: true,
      placeholder: 'Enter Twitter thread URL',
      validation: /twitter\.com\/\w+\/status\/\d+|x\.com\/\w+\/status\/\d+/,
      examples: [
        'https://twitter.com/username/status/1234567890',
        'https://x.com/username/status/1234567890',
        'https://twitter.com/elonmusk/status/...',
      ],
      helpText:
        'Enter the URL of the first tweet in a thread. We will automatically detect and summarize the entire conversation.',
      showExamples: true,
      showHelpText: true,
    },
  },

  // Output features
  outputs: {
    summary: true,
    chat: true,
    mindmap: true,
    translation: true,
    keyPoints: true,
    transcript: true,
    download: true,
    share: true,
  },

  // Backend integration
  api: {
    endpoint: '/summarize',
    method: 'POST',
    contentType: 'twitter-thread',
    timeout: 45000, // 45 seconds for social media processing
  },

  // UI customization (Level 3: Custom component example)
  ui: {
    // Basic styling
    primaryColor: '#1da1f2',
    secondaryColor: '#1991db',
    icon: '🐦',

    // Custom styles (Level 2)
    customStyles: {
      container: '',
      inputArea: 'bg-white shadow-xl rounded-2xl border border-blue-100',
      button:
        'bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:scale-105',
    },

    // Custom components (Level 3) - commented out for now
    customComponents: {
      input: undefined, // Use default
      // output: TwitterThreadOutput, // Custom component to show social media metrics
      output: undefined, // Use default for now
      layout: undefined,
    },

    theme: 'light',
  },

  // Validation rules
  validation: {
    required: true,
    minSize: 0,
    maxSize: 0, // No file size limit for URLs
    allowedDomains: ['twitter.com', 'x.com'],
    blockedDomains: [],
  },

  // Feature flags
  features: {
    beta: false,
    premium: false,
    experimental: false,
  },

  // Metadata
  author: 'TubeOnAI',
  createdAt: '2024-01-01',
  updatedAt: '2024-01-01',
};
